import React, { createContext, PropsWithChildren, useContext } from 'react';
import { DISPATCH_ARG } from '@nile/client_management/src/Contracts/Constants';
import {
  Client,
  Template
} from '@nile/client_management/src/Contracts/Types/types';
import { ProvisionRule, ContractIncludedItem } from '@nile/types';

export interface IDeliveryContext {
  nodes: Array<{ id: string; pId?: string }>;
  client: Client;
  template: Template;
  isDeliveryMapLoading: boolean;
  setIsDeliveryMapLoading: React.Dispatch<boolean>;
  isReadOnly: boolean;
  dispatchProvisionRulesList: (action: DISPATCH_ARG) => void;
  provisionRulesList: Array<ProvisionRule>;
  isTemplate: boolean;
  unProvisionedItems: Array<any>;
  setUnProvisionedItems: React.Dispatch<Array<any>>;
  contractIncludedItems: ContractIncludedItem[];
  contractProvisionRule: ProvisionRule;
}

const DeliveryMapContext = createContext<IDeliveryContext | undefined>(
  undefined
);

export function DeliveryMapProvider({
  children,
  value
}: PropsWithChildren<{ value: IDeliveryContext }>) {
  return (
    <DeliveryMapContext.Provider value={value}>
      {children}
    </DeliveryMapContext.Provider>
  );
}

export function useDeliveryMapContext() {
  const ctx = useContext(DeliveryMapContext);

  if (ctx === undefined) {
    throw Error('use `useDeliveryMapContext` inside DeliveryMapProvider');
  }

  return ctx;
}
